import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { markTaskAsCompletedError } from "@planzone/dto";

const initialState: State = [];

function handleRequest(
  state: State,
  { task }: Boundaries["markTaskAsCompleted"]["request"],
): State {
  const index = state.findIndex((req) => req.task.uuid === task.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          request: setRequestStateToPending(),
          task,
          error: markTaskAsCompletedError,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          request: setRequestStateToPending(),
          task,
          error: markTaskAsCompletedError,
        },
      ];
}

function handleSuccess(
  state: State,
  { task }: Boundaries["markTaskAsCompleted"]["success"],
): State {
  const index = state.findIndex((req) => req.task.uuid === task.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          request: setRequestStateToSuccess(),
          task,
          error: markTaskAsCompletedError,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          request: setRequestStateToSuccess(),
          task,
          error: markTaskAsCompletedError,
        },
      ];
}

function handleFailure(
  state: State,
  { task, error }: Boundaries["markTaskAsCompleted"]["failure"],
): State {
  const index = state.findIndex((req) => req.task.uuid === task.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          request: setRequestStateToFailure(),
          task,
          error,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          request: setRequestStateToFailure(),
          task,
          error,
        },
      ];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.markTaskAsCompletedRequested]: handleRequest,
    [events.markTaskAsCompletedSucceeded]: handleSuccess,
    [events.markTaskAsCompletedFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
